module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/price-1-9aa9c18e317d59ef61026a813f2bc6d7.svg";